
import { IAccessibleViewImplementation } from '../../../../platform/accessibility/browser/accessibleViewRegistry.js';

export class InlineCompletionsAccessibleView implements IAccessibleViewImplementation {
}
